import { createAsyncThunk } from "@reduxjs/toolkit";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import moment from "moment";
import { axios } from "../../common";

import OptionHeaders from "../options";
const { token, baseUrl, employeOid } = OptionHeaders();
const TIME_KEEPING_ONLINE_SHOW = "timekeeping/showTimekeepingOnline";
const TIME_KEEPING_ONLINE_DATA_SHOW = "timekeeping/showTimekeepingOnlineData";
const TIME_KEEPING_ONLINE_APPROVAL_SHOW =
  "timekeeping/showTimekeepingOnlineApproval";

export const showTimekeepingOnline = createAsyncThunk(
  TIME_KEEPING_ONLINE_SHOW,
  async (payload, thunkAPI) => {
    try {
      const { data } = await axios.get("TimeKeepingOnline", {
        params: {
          $expand: "Shift,Employee($expand=Department,Position)",
          $filter:
            "Employee/Oid eq " +
            payload?.EmployeeOid +
            "" +
            " and LogTime ge " +
            payload.FromDate +
            "" +
            " and LogTime le " +
            payload.ToDate +
            "" +
            " and RequestStatus in [" +
            payload.Status.map((status) => `'${status}'`) +
            "]",
        },
      });
      return data.value;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const getTimekeepingApproval = createAsyncThunk(
  TIME_KEEPING_ONLINE_APPROVAL_SHOW,
  async (payload, thunkAPI) => {
    try {
      const { data } = await axios.post(
        "TimeKeepingOnlineForApproval",
        payload
      );
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const showTimekeepingOnlineData = createAsyncThunk(
  TIME_KEEPING_ONLINE_DATA_SHOW,
  async (payload, thunkAPI) => {
    const FromDate = moment(new Date(payload.FromDate)).format();
    const ToDate = moment(new Date(payload.ToDate)).format();
    try {
      const user = new DataSource({
        store: new ODataStore({
          url: `${baseUrl}TimeKeepingOnlineData`,
          key: "Oid",
          version: 4,
          beforeSend: (request) => {
            request.headers["token"] = token;
          },
        }),
        expand: ["Shift,Employee($expand=Department,Position)"],
        filter: [
          "Employee/Oid eq " +
            employeOid +
            "" +
            " and FromDate ge " +
            FromDate +
            "" +
            " and ToDate le " +
            ToDate +
            "" +
            " and RequestStatus in [" +
            payload.Status.map((status) => `'${status.toString(",")}'`) +
            "]",
        ],
      });
      return user;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
